import Error from '../model/Error';
import axios from 'axios';

export default class DogBreedRepository {

    static findAvailableBreeds(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/dogs/breeds`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findAvailableBreedSpecializations(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/dogs/breedSpecializations`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
